import moment from 'moment';

export function formatDateFilter(value) {
    if (value) {
        value = moment.isMoment(value) ? value : moment(value);
        const dateFormat = i18n.t('shared.date_only_format');
        return value.format(dateFormat);
    }
};

export function formatDateTimeFilter(value) {
    if (value) {
        value = moment.isMoment(value) ? value : moment(value);
        const dateFormat = i18n.t('shared.date_format');
        return value.format(dateFormat);
    }
};
